<template>
    <div class="funnel-section mt-12">
        <div class="py-12">
              <div class="text-h3 font-weight-bold py-3" v-html="$t('home.funnel.title')"></div>
              <div class="text-h5 grey--text py-3" v-html="$t('home.funnel.subtitle')"></div>
              <v-row class="pt-6">
                <v-col cols="12" md="4" sm="12" class="mt-6">
                  <!-- <v-btn color="primary" x-large class="mx-auto my-6" elevation="0" block to="/cadastrar">REGISTER NOW<v-icon small class="ml-12">mdi-arrow-right</v-icon></v-btn> -->
                  <v-card elevation="0" color="#E7EBF5" class="mt-6" v-for="(card, index) in $t('home.funnel.boxes')" :key="index">
                    <v-card-title>
                      <div class="primary--text">
                        <v-img :src="`https://lion-web-site.s3.amazonaws.com/public/${card.icon}`" width="42" class="my-9"></v-img>
                        {{ card.title }}
                      </div>
                    </v-card-title>
                    <v-card-text><div v-html="card.subtitle"></div></v-card-text>
                  </v-card>
                  
                </v-col>
                <v-col>
                  <div class="d-flex flex-wrap py-12 my-12 mx-3 pa-md-12 ma-md-12">
                    <div class="d-flex">
                      <FourDots class="mt-3"></FourDots>
                      <div class="mx-3" style="flex: 1 1 50%">
                        <div class="text-h5 primary--text font-weight-bold" v-html="$t('home.funnel.before.title')"></div>
                        <div v-html="$t('home.funnel.before.subtitle')"></div>
                      </div>
                    </div>
                    <v-img src="@/assets/funnel.svg" width="100%" max-height="430" class="mx-md-auto mx-3 my-0" contain position="center"></v-img>
                    <div class="d-flex">
                      <FourDots class="mt-3"></FourDots>
                      <div class="mx-3" style="flex: 1 1 50%">
                        <div class="text-h5 primary--text font-weight-bold" v-html="$t('home.funnel.after.title')"> </div>
                       <div v-html="$t('home.funnel.after.subtitle')"></div>
                      </div>
                    </div>
                  </div>
                  
                </v-col>

              </v-row>

              <!-- <div class="text-h2 text-center font-weight-bold pt-12 pb-3">+5K Transfer payment</div>
              <div class="text-h5 text-center grey--text py-3">to media vendors</div>
              <div class="d-flex justify-center pt-6 pb-3">
                <v-btn color="primary" x-large class="mx-auto" elevation="0">JOIN THE NETWORK<v-icon small class="ml-12">mdi-arrow-right</v-icon></v-btn>
              </div> -->
        
          </div>
          <v-item-group>
            <v-item  v-slot="{ active, toggle }">
              <v-card
              :color="active ? 'primary' : 'primary'"
                class="d-flex align-center px-12 py-9 text-h4 justify-space-between"
                dark
               @click="toggle"
               href="https://calendly.com/canaldoanuncio/licacao" target="_blank"
              >
                <strong>
                  <v-icon x-large class="mr-3">mdi-video</v-icon>
                  {{ $t("home.funnel.cta" )}}
                </strong>
                <v-icon  x-large>mdi-arrow-right</v-icon>
              </v-card>
            </v-item>
            </v-item-group>

    </div>
</template>
<script>
import FourDots from '@/interface/FourDots.vue';
export default {
    name: "FunnelSection",
    components: { FourDots }
}
</script>